module.exports = __webpack_public_path__ + "static/customer-experience-and-design-dc3ad7359333e306aa612d0fc509e149.jpg";